// Muted, desaturated jewel tones — consistent with the app's restrained
// "classic pro" palette (no neon/candy colors). Deliberately avoids hues
// used for semantic meaning elsewhere (green = Completed, red = Declined,
// brand blue = primary accent/selection).
const AVATAR_COLORS = [
    '#4C5D99',
    '#7A4F94',
    '#99507A',
    '#99694C',
    '#94874C',
    '#4C9490', // teal
];
export const getColorForLetter = (letter) => {
    if (!letter)
        return AVATAR_COLORS[0];
    const index = letter.toUpperCase().charCodeAt(0) % AVATAR_COLORS.length;
    return AVATAR_COLORS[index];
};
